import { render, staticRenderFns } from "./variant.vue?vue&type=template&id=1eac0b59&scoped=true&"
import script from "./variant.vue?vue&type=script&lang=js&"
export * from "./variant.vue?vue&type=script&lang=js&"
import style0 from "./variant.vue?vue&type=style&index=0&id=1eac0b59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eac0b59",
  null
  
)

component.options.__file = "variant.vue"
export default component.exports